import { put, call } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import * as actions from '../actions';

import { TEXTS } from '../../constants/languages';
import { toastOptionsSuccess, toastOptionsError } from '../../styles/toast';

import Label from '../../models/labels/Label';

import { convertTasksStructure } from '../../utils/taskHelper';

import * as localStorageService from '../../services/localStorage';

import { fetchRequest } from '../../server';
import { API_URL, API_PATH_LABELS, API_PATH_TASKS } from '../../constants/server';

const language = localStorageService.getLanguage();

export function* getLabelsSaga() {
  try {
    yield put(actions.getLabelsStart());

    const labels = yield call(fetchRequest, `${API_URL}${API_PATH_LABELS}`, 'GET');

    yield put(
      actions.getLabelsSuccess(
        (labels.data || []).map((label) => {
          return new Label().getLabel(label);
        }),
      ),
    );
  } catch (error) {
    toast(error.message, toastOptionsError);
    yield put(actions.getLabelsFail(error));
  }
}

export function* createLabelSaga(action) {
  try {
    yield put(actions.createLabelStart());

    const labels = yield call(
      fetchRequest,
      `${API_URL}${API_PATH_LABELS}`,
      'POST',
      JSON.stringify(new Label(action.payload.label).getCreateLabelDto()),
    );

    yield put(actions.createLabelSuccess());
    yield put(
      actions.getLabelsSuccess(
        (labels.data || []).map((label) => {
          return new Label().getLabel(label);
        }),
      ),
    );

    toast(TEXTS[language].LABEL_CREATED, toastOptionsSuccess);
  } catch (error) {
    toast(error.message, toastOptionsError);
    yield put(actions.createLabelFail(error));
  }
}

export function* updateLabelSaga(action) {
  try {
    yield put(actions.updateLabelStart());
    yield put(actions.getTasksServerStart());

    if (!action.payload.label.id) {
      throw new Error('No label');
    }

    const labels = yield call(
      fetchRequest,
      `${API_URL}${API_PATH_LABELS}/${action.payload.label.id}`,
      'PATCH',
      JSON.stringify(new Label(action.payload.label).getCreateLabelDto()),
    );

    yield put(actions.updateLabelSuccess());
    yield put(
      actions.getLabelsSuccess(
        (labels.data || []).map((label) => {
          return new Label().getLabel(label);
        }),
      ),
    );

    const tasksStructure = yield call(fetchRequest, `${API_URL}${API_PATH_TASKS}`, 'GET');

    yield put(actions.getTasksServerSuccess(convertTasksStructure(tasksStructure.data)));

    toast(TEXTS[language].LABEL_UPDATED, toastOptionsSuccess);
  } catch (error) {
    toast(error.message, toastOptionsError);
    yield put(actions.updateLabelFail(error));
    yield put(actions.getTasksServerFail(error));
  }
}

export function* removeLabelSaga(action) {
  try {
    yield put(actions.removeLabelStart());
    yield put(actions.getTasksServerStart());

    if (!action.payload.id) {
      throw new Error('No label');
    }

    const labels = yield call(fetchRequest, `${API_URL}${API_PATH_LABELS}/${action.payload.id}`, 'DELETE');

    yield put(actions.removeLabelSuccess());
    yield put(
      actions.getLabelsSuccess(
        (labels.data || []).map((label) => {
          return new Label().getLabel(label);
        }),
      ),
    );

    const tasksStructure = yield call(fetchRequest, `${API_URL}${API_PATH_TASKS}`, 'GET');

    yield put(actions.getTasksServerSuccess(convertTasksStructure(tasksStructure.data)));

    toast(TEXTS[language].LABEL_DELETED, toastOptionsSuccess);
  } catch (error) {
    toast(error.message, toastOptionsError);
    yield put(actions.removeLabelFail(error));
    yield put(actions.getTasksServerFail(error));
  }
}

export function* refreshLabelsSaga() {
  try {
    const labels = yield call(fetchRequest, `${API_URL}${API_PATH_LABELS}`, 'GET');

    yield put(
      actions.getLabelsSuccess(
        (labels.data || []).map((label) => {
          return new Label().getLabel(label);
        }),
      ),
    );

    return labels;
  } catch (error) {
    return error;
  }
}
